import {
    SIX_DEVICE_AUTH_ATTEMPTED,
    SIX_DEVICE_AUTH_LAST_ACTIVITY_TS,
    SIX_DEVICE_AUTH_VERIFIED,
} from '@/common/storage/keys'

export function getDeviceAuthVerified() {
    try {
        return !!sessionStorage.getItem(SIX_DEVICE_AUTH_VERIFIED)
    } catch {
        return false
    }
}

export function setDeviceAuthVerified() {
    try {
        sessionStorage.setItem(SIX_DEVICE_AUTH_VERIFIED, '1')
    } catch {
        // ignore
    }
}

export function getDeviceAuthAttempted() {
    try {
        return !!sessionStorage.getItem(SIX_DEVICE_AUTH_ATTEMPTED)
    } catch {
        return false
    }
}

export function setDeviceAuthAttempted() {
    try {
        sessionStorage.setItem(SIX_DEVICE_AUTH_ATTEMPTED, '1')
    } catch {
        // ignore
    }
}

export function clearDeviceAuthAttempted() {
    try {
        sessionStorage.removeItem(SIX_DEVICE_AUTH_ATTEMPTED)
    } catch {
        // ignore
    }
}

export function getLastDeviceAuthActivityTs() {
    try {
        const raw = sessionStorage.getItem(SIX_DEVICE_AUTH_LAST_ACTIVITY_TS)
        const value = raw ? Number(raw) : NaN
        return Number.isFinite(value) ? value : null
    } catch {
        return null
    }
}

export function touchDeviceAuthActivity() {
    try {
        sessionStorage.setItem(SIX_DEVICE_AUTH_LAST_ACTIVITY_TS, String(Date.now()))
    } catch {
        // ignore
    }
}

export function clearDeviceAuthSession() {
    try {
        sessionStorage.removeItem(SIX_DEVICE_AUTH_VERIFIED)
        sessionStorage.removeItem(SIX_DEVICE_AUTH_ATTEMPTED)
        sessionStorage.removeItem(SIX_DEVICE_AUTH_LAST_ACTIVITY_TS)
    } catch {
        // ignore
    }
}
